import Vue from 'vue';
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: `#${process.env.VUE_APP_COLOR_PRIMARY}`,
        secondary: `#${process.env.VUE_APP_COLOR_SECONDARY}`,
        accent: `#${process.env.VUE_APP_COLOR_ACCENT}`,
        gray: `#${process.env.VUE_APP_COLOR_GRAY}`,
        background: '#FFFFFF',
        background2: '#F0F0F0',
        background3: '#E8E8E8',
        background4: '#E0E0E0',
        tableBackground: '#FFFFFF',
        tableBackgroundAlt: '#EEEEEE',
        tableRowHover: '#CCCCCC',
        tableHeaderColor: '#FFFFFF',
        tableHeaderText: '#000000',
        foreground: '#000000',
        foreground2: '#333333',
        foreground3: '#6B6B6B',
        foreground4: '#777777',
        darkButtonText: '#FFFFFF',
        blue: '#0F689C',
        blueText: '#0F689C',
        orange: '#E16600',
        orangeText: '#E16600',
        yellow: '#F3EA78',
        yellowText: '#F3EA78',
        green: '#085738',
        greenText: '#085738',
        red: '#D50000',
        redText: '#D50000',
        success: '#085738',
        error: '#FF5252',
        rowhighlight: '#FFE81C',
        rowfuture: '#FF8833',
        borderLine: '#949494'
      },
      dark: {
        primary: `#${process.env.VUE_APP_COLOR_PRIMARY}`,
        secondary: `#${process.env.VUE_APP_COLOR_SECONDARY}`,
        accent: `#${process.env.VUE_APP_COLOR_ACCENT}`,
        gray: `#${process.env.VUE_APP_COLOR_GRAY}`,
        background: '#121212',
        background2: '#2A2A2A',
        background3: '#444444',
        background4: '#555555',
        tableBackground: '#1E1E1E',
        tableBackgroundAlt: '#2E2E2E',
        tableRowHover: '#4E4E4E',
        tableHeaderColor: '#1E1E1E',
        tableHeaderText: '#E6EDF3',
        foreground: '#F0EDF3',
        foreground2: '#DDDDDD',
        foreground3: '#BBBBBB',
        foreground4: '#999999',
        darkButtonText: '#F0EDF3',
        blue: '#4090A0',
        blueText: '#9CDCFE',
        orange: '#D89840',
        orangeText: '#F0A03C',
        yellow: '#B0B040',
        yellowText: '#F0E050',
        green: '#509050',
        greenText: '#94CEA8',
        red: '#B02020',
        redText: '#FF5252',
        success: '#408040',
        error: '#B02020',
        rowhighlight: '#FFE81C',
        rowfuture: '#FF8833',
        borderLine: '#949494'
      },
    },
  },
});
